import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../components/navbar/navbar";
import { Link, useNavigate } from "react-router-dom";
import { useHooks } from "../../utils/getHooks";
import SideFilter from "../../components/side-filter";
import ListProperty from "../../components/list-property";
import GridProperty from "../../components/grid-property";
import { viewSpaceList } from "../../services/ApiServices";
import { useDispatch } from "react-redux";
import { mySpace } from "../../store/slices/APIResponseSlice";
import GoogleMapReact from 'google-map-react';
import Footer from "../../components/footer";
import processor from '../../assets/css/plugins/ajax-loader.gif'
import { GoogleMap, Marker } from "@react-google-maps/api";

const MySpace = () => {
    let dispatch = useDispatch();
    let hooks = useHooks();
    let navigate = useNavigate();
    console.log("hook", hooks.getMySpaceList);
    const seachValue = hooks.getMySpaceList
    console.log("seachValue", seachValue);

    const [show, setShow] = useState<boolean>(false);
    const [spaceList, setSpace] = useState<any[]>(hooks.getMySpaceList);
    const [layourType, setLayoutType] = useState<string>("1");
    const [isLoading, setLoading] = useState<boolean>(false);
    const [latlng, setLatlng] = useState<any>([]);
    // const [defaultProps, setDefaultProps] = useState<any>({
    //     center: {
    //         lat: 48.866024, // Latitude for San Francisco
    //         lng: 2.340041 // Longitude for San Francisco
    //     },
    //     zoom: 17,
    // });

    // const spaceList = hooks.getSpaceList
    var defaultProps = {
        center: {
            lat: 48.866024, // Latitude for San Francisco
            lng: 2.340041 // Longitude for San Francisco
        },
        zoom: 20,
    };

    console.log("spaceList", hooks.getMySpaceList);

    useEffect(() => {
        // setSpace(hooks.getMySpaceList)
        mySpaceAPICall()
    }, [])

    const mySpaceAPICall = () => {
        // e.preventDefault()
        setLoading(true);

        viewSpaceList().then((res) => {
            console.log("get search space response", res);

            if (res?.status === "success") {
                dispatch(mySpace(res.data))
                const latlngList = res?.data?.map((item: any) => {
                    return (
                        {
                            position: {
                                lat: Number(item?.latitude),
                                lng: Number(item?.longitude),
                            }
                        }
                    )
                })
                setLatlng(latlngList)
                defaultProps = {
                    ...defaultProps,
                    center: {
                        lat: res?.data[0]?.latitude,
                        lng: res?.data[0]?.longitude
                    }
                }
                console.log('latlngList', latlngList)
                setLoading(false)
            } else if (res?.message === "Unauthenticated.") {
                navigate("/")
            }
            else if (res?.status === "error") {
                dispatch(mySpace(res.data))
                setLoading(false)
            } else {
                console.log("search space error", res);
                setLoading(false)
            }
        })
    }
    console.log("defaultProps", defaultProps);

    const mapRef = useRef(null);
    const mapsRef = useRef(null);

    const handleApiLoaded = ({ map, maps }: any) => {
        mapRef.current = map;
        mapsRef.current = maps;

        if (latlng.length > 0) {
            const bounds = new maps.LatLngBounds();
            latlng.forEach((loc: any) => {
                // new maps.Marker({
                //     position: { lat: loc.lat, lng: loc.lng },
                //     map: map,
                // });
                bounds.extend(new maps.LatLng(loc.lat, loc.lng));
            });
            map.fitBounds(bounds);
        }
    };

    const handleOnLoad = (map: any) => {
        const bounds = new google.maps.LatLngBounds();
        latlng.forEach(({ position }: any) => bounds.extend(position));
        map.fitBounds(bounds);
    };

    return (
        <>
            <Navbar transparent={false} />
            <div className="page-title">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12">
                            <h2 className="ipt-title">My Space</h2>
                        </div>
                    </div>
                </div>
            </div>
            {layourType === "3" &&
                <div className="home-map-banner full-wrapious">
                    <div style={{ height: '600px', width: '100%' }}>
                        <GoogleMap
                            onLoad={handleOnLoad}
                            mapContainerStyle={{ width: "100vw", height: "100vh" }}
                        >
                            {latlng.map(({ position }: any, index: any) => (
                                <Marker
                                    key={index}
                                    position={position}
                                >
                                </Marker>
                            ))}
                        </GoogleMap>
                        {/* <GoogleMapReact
                            bootstrapURLKeys={{ key: 'AIzaSyApsnfh0LcjwuVtDEEYVrzqCSw075qYEvg' }}
                            defaultCenter={defaultProps.center}
                            defaultZoom={defaultProps.zoom}
                            yesIWantToUseGoogleMapApiInternals
                            onGoogleApiLoaded={handleApiLoaded}
                        >
                            {
                                latlng?.map((item: any, index: any) => {
                                    return (
                                        <Marker
                                            key={index}
                                            lat={item?.lat}
                                            lng={item?.lng}
                                        />
                                    )
                                })
                            }
                        </GoogleMapReact> */}
                    </div>
                </div>
            }
            <section className="gray-simple">
                <div className="container justify-center d-block align-center">
                    <div className="row m-0">
                        {/* <FilterTop /> */}
                    </div>
                    <div className="row">
                        <div className="col-lg-10 col-md-12">
                            <div className="filter_search_opt">
                                <Link to="#" className="btn btn-dark full-width mb-4" onClick={() => setShow(!show)}>
                                    <span className="svg-icon text-light svg-icon-2hx me-2">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M19.0759 3H4.72777C3.95892 3 3.47768 3.83148 3.86067 4.49814L8.56967 12.6949C9.17923 13.7559 9.5 14.9582 9.5 16.1819V19.5072C9.5 20.2189 10.2223 20.7028 10.8805 20.432L13.8805 19.1977C14.2553 19.0435 14.5 18.6783 14.5 18.273V13.8372C14.5 12.8089 14.8171 11.8056 15.408 10.964L19.8943 4.57465C20.3596 3.912 19.8856 3 19.0759 3Z" fill="currentColor" />
                                        </svg>
                                    </span>Open Filter Option
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="row">

                        <div className="col-lg-12 col-md-12 list-layout">
                            <div className="row justify-content-center">
                                <div className="col-lg-10 col-md-10">
                                    <div className="item-shorting-box">
                                        <div className="item-shorting clearfix">
                                            {/* <div className="left-column pull-left"><h4 className="fs-6 m-0">Found 1-10 of 142 Results</h4></div> */}
                                        </div>
                                        <div className="item-shorting-box-right">

                                            <ul className="shorting-list">

                                                <li>
                                                    <Link to="#" className={`${layourType === "1" && "active"} w-12 h-12`} onClick={() => setLayoutType("1")}>
                                                        <span className={`svg-icon ${layourType === "1" ? "text-seegreen" : "text-muted-2"} svg-icon-2hx`}>
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path opacity="0.3" d="M14 10V20C14 20.6 13.6 21 13 21H10C9.4 21 9 20.6 9 20V10C9 9.4 9.4 9 10 9H13C13.6 9 14 9.4 14 10ZM20 9H17C16.4 9 16 9.4 16 10V20C16 20.6 16.4 21 17 21H20C20.6 21 21 20.6 21 20V10C21 9.4 20.6 9 20 9Z" fill="currentColor" />
                                                                <path d="M7 10V20C7 20.6 6.6 21 6 21H3C2.4 21 2 20.6 2 20V10C2 9.4 2.4 9 3 9H6C6.6 9 7 9.4 7 10ZM21 6V3C21 2.4 20.6 2 20 2H3C2.4 2 2 2.4 2 3V6C2 6.6 2.4 7 3 7H20C20.6 7 21 6.6 21 6Z" fill="currentColor" />
                                                            </svg>
                                                        </span>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" className={`${layourType === "2" && "active"} w-12 h-12`} onClick={() => setLayoutType("2")}>
                                                        <span className={`svg-icon ${layourType === "2" ? "text-seegreen" : "text-muted-2"} svg-icon-2hx`}>
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <rect x="2" y="2" width="9" height="9" rx="2" fill="currentColor" />
                                                                <rect opacity="0.3" x="13" y="2" width="9" height="9" rx="2" fill="currentColor" />
                                                                <rect opacity="0.3" x="13" y="13" width="9" height="9" rx="2" fill="currentColor" />
                                                                <rect opacity="0.3" x="2" y="13" width="9" height="9" rx="2" fill="currentColor" />
                                                            </svg>
                                                        </span>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" className={`${layourType === "3" && "active"} w-12 h-12`} onClick={() => setLayoutType("3")}>
                                                        <span className={`svg-icon ${layourType === "3" ? "text-seegreen" : "text-muted-2"} svg-icon-2hx`}>
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path opacity="0.3" d="M14 10V20C14 20.6 13.6 21 13 21H10C9.4 21 9 20.6 9 20V10C9 9.4 9.4 9 10 9H13C13.6 9 14 9.4 14 10ZM20 9H17C16.4 9 16 9.4 16 10V20C16 20.6 16.4 21 17 21H20C20.6 21 21 20.6 21 20V10C21 9.4 20.6 9 20 9Z" fill="currentColor" />
                                                                <path d="M7 10V20C7 20.6 6.6 21 6 21H3C2.4 21 2 20.6 2 20V10C2 9.4 2.4 9 3 9H6C6.6 9 7 9.4 7 10ZM21 6V3C21 2.4 20.6 2 20 2H3C2.4 2 2 2.4 2 3V6C2 6.6 2.4 7 3 7H20C20.6 7 21 6.6 21 6Z" fill="currentColor" />
                                                            </svg>
                                                        </span>
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row justify-content-center g-4">
                                {hooks.getMySpaceList.length === 0 && isLoading ?
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 " style={{}}>
                                        <div className="fw-bold ms-1 my-0 text-center mt-3" style={{ color: "#AFABAB" }}><img src={processor} width={'10%'} height={'10%'} /></div>
                                    </div> :
                                    hooks.getMySpaceList.length === 0 && !isLoading ?
                                        <div className="col-xl-12 col-lg-10 col-md-12 col-sm-12 " style={{ padding: 50 }}>
                                            <h5 className="fs-3 fw-bold ms-1 my-0 text-center" style={{ color: "#AFABAB", }}>No Data Available</h5>
                                        </div>
                                        :
                                        hooks.getMySpaceList.map((item: any, index: any) => {
                                            if (layourType === "1") {
                                                return (
                                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12" key={index}>
                                                        <ListProperty
                                                            item={item}
                                                            isEditable={true}
                                                            mySpaceAPICall={() => mySpaceAPICall()}
                                                        />
                                                    </div>
                                                )
                                            } else if (layourType === "2") {
                                                return (
                                                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12" key={index}>
                                                        <GridProperty
                                                            item={item}
                                                            border={false}
                                                            isEditable={true}
                                                        />
                                                    </div>
                                                )
                                            } else if (layourType === "3") {
                                                return (
                                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12" key={index}>
                                                        <ListProperty
                                                            item={item}
                                                            isEditable={true}
                                                            mySpaceAPICall={() => mySpaceAPICall()}
                                                        />
                                                    </div>
                                                )
                                            }
                                        })}
                            </div>
                            {/* <div className="row">
                         <div className="col-lg-12 col-md-12 col-sm-12">
                             <ul className="pagination p-center">
                                 <li className="page-item">
                                     <Link className="page-link" to="#" aria-label="Previous"><i className="fa-solid fa-arrow-left-long"></i><span className="sr-only">Previous</span></Link>
                                 </li>
                                 <li className="page-item"><Link className="page-link" to="#">1</Link></li>
                                 <li className="page-item"><Link className="page-link" to="#">2</Link></li>
                                 <li className="page-item active"><Link className="page-link" to="#">3</Link></li>
                                 <li className="page-item"><Link className="page-link" to="#">...</Link></li>
                                 <li className="page-item"><Link className="page-link" to="#">18</Link></li>
                                 <li className="page-item">
                                     <Link className="page-link" to="#" aria-label="Next"><i className="fa-solid fa-arrow-right-long"></i><span className="sr-only">Next</span></Link>
                                 </li>
                             </ul>
                         </div>
                     </div> */}
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
};

export default MySpace;
